import React from 'react';
import styles from './HorizontalSeparator.styles';

export default function HorizontalSeparator({ style }) {
    return <div style={{ ...styles.borderContainer, ...style }}></div>
}